import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { CoreService } from "../services/core.service";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requestCount = 0; // Track the number of active requests

  constructor(public coreServiceService: CoreService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Increment the request count and show the loader
    this.requestCount++;
    if (this.requestCount === 1) {
      this.coreServiceService.hideShowLoader(true); // Only show loader when the first request is made
    }

    return next.handle(req).pipe(
      finalize(() => {
        this.requestCount--; // Decrement the request count
        if (this.requestCount === 0) {
          // Hide the loader only when all requests are complete
          setTimeout(() => {
            this.coreServiceService.hideShowLoader(false);
          }, 100);
        }
      })
    );
  }
}
